import React, {useRef, useState} from 'react';
import styles from './styles';
// import DataTable from '../../DataTable';
import ContactCell from './ContactCell';
import {Button} from '@xpertdox_js/xdcomponents';
import { trackActivity } from '../../../utils/activityTracker'
import { UserContext } from '../../../Context/UserContext'
import { InstanceContext } from '../../../InstanceContext'

const ContactTable = props => {

  const [page, setPage] = useState(1);
  const tableElement = useRef();
  const { user } = React.useContext(UserContext)
  const { contextInstance } = React.useContext(InstanceContext)

  const contactCount = props.contacts.length;
  const totalPages = Math.ceil(contactCount / 50);
  const data = props.contacts.slice( (page - 1) * 50, page * 50);

  const handleActivityLogUpdate = (_id) => {
    trackActivity({
      body: {
        _id,
        instance: contextInstance || user.instance,
        user: user.id
      }
    })
  }

  const resetScroll = () => {
    tableElement.current.scrollTop = 0;
    handleActivityLogUpdate(`ContactTable.resetScroll`)
  }
  const pageBack = () => {
    handleActivityLogUpdate(`ContactTable.pageBack`)
    setPage(page - 1 ? page - 1 : page);
    resetScroll();
  }
  const pageUp = () => {
    handleActivityLogUpdate(`ContactTable.pageUp`)
    setPage(page + 1 <= totalPages ? page + 1 : page);
    resetScroll();
  }

  const noBorder = {
    borderRight: 'none',
    borderBottom: 'none',
  }

  return(
    <div style={styles.ctContainer} ref={tableElement}>

      <div style={{...styles.clearfix, ...styles.headers}}>
        <div style={{...styles.contactCell, ...noBorder}}>
          <span style={styles.heading}>Contact Name</span>
        </div>
        <div style={{...styles.contactCell, ...noBorder}}>
          <span style={styles.heading}>Contact Email</span>
        </div>
        <div style={{
          ...styles.contactCell,
          ...styles.contactCellControl,
          background: styles.heading.background,
          ...noBorder,
        }}></div>
      </div>
      <div style={styles.cellsWrap}>
        {data.map((obj, i) => {
          return <ContactCell
            key={obj.id}
            index={i}
            data={obj}
            addRemovedContact={props.addRemovedContact}
          />
        })}
      </div>
      <div style={styles.toolbar}>
        <Button
          styles={styles.arrowLeft}
          hoverStyles={styles.arrowHov}
          onClick={pageBack}
        >
          <svg style={{...styles.arrowSVG, float: 'left'}} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M216.4 163.7c5.1 5 5.1 13.3.1 18.4L155.8 243h231.3c7.1 0 12.9 5.8 12.9 13s-5.8 13-12.9 13H155.8l60.8 60.9c5 5.1 4.9 13.3-.1 18.4-5.1 5-13.2 5-18.3-.1l-82.4-83c-1.1-1.2-2-2.5-2.7-4.1-.7-1.6-1-3.3-1-5 0-3.4 1.3-6.6 3.7-9.1l82.4-83c4.9-5.2 13.1-5.3 18.2-.3z"/></svg>
        </Button>
        <div style={styles.pageCount}>
          <span>
            {(page === 1 ? 1 : (page - 1)  * 50) + ' - '}
            {props.count < page * 50 ? props.count : page * 50}
            {' of ' + props.count}
          </span>
        </div>
        <Button
          styles={styles.arrowRight}
          hoverStyles={styles.arrowHov}
          onClick={pageUp}
        >
          <svg style={{...styles.arrowSVG, float: 'right'}} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M295.6 163.7c-5.1 5-5.1 13.3-.1 18.4l60.8 60.9H124.9c-7.1 0-12.9 5.8-12.9 13s5.8 13 12.9 13h231.3l-60.8 60.9c-5 5.1-4.9 13.3.1 18.4 5.1 5 13.2 5 18.3-.1l82.4-83c1.1-1.2 2-2.5 2.7-4.1.7-1.6 1-3.3 1-5 0-3.4-1.3-6.6-3.7-9.1l-82.4-83c-4.9-5.2-13.1-5.3-18.2-.3z"/></svg>
        </Button>
      </div>
    </div>
  );
}

export default ContactTable;
